"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VisaFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var VisaFilled = function VisaFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 3,
    fill: "#ECEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.405 8.142l-3.243 7.737H9.046L7.451 9.704c-.098-.38-.182-.52-.477-.68-.48-.26-1.275-.506-1.974-.658l.048-.224h3.406c.433 0 .824.288.922.788l.843 4.478 2.083-5.266h2.103zm8.29 5.21c.01-2.042-2.823-2.154-2.804-3.066.006-.278.27-.573.849-.649.287-.037 1.077-.066 1.974.347l.35-1.64A5.368 5.368 0 0021.194 8c-1.979 0-3.371 1.052-3.383 2.558-.012 1.114.994 1.735 1.753 2.106.78.379 1.041.622 1.038.961-.005.52-.622.748-1.197.757-1.007.016-1.591-.271-2.057-.489l-.362 1.696c.467.215 1.33.402 2.226.411 2.102 0 3.478-1.039 3.485-2.647zm5.225 2.527h1.851l-1.616-7.737h-1.709a.912.912 0 00-.852.567l-3.003 7.17h2.102l.417-1.155h2.569l.24 1.155zm-2.234-2.741l1.054-2.906.607 2.906h-1.66zm-8.42-4.996l-1.656 7.737h-2.002l1.656-7.737h2.001z",
    fill: "#1A1F70"
  }));
};

exports.VisaFilled = VisaFilled;
var _default = VisaFilled;
exports.default = _default;